<template>
    <b-modal v-model="visible" ref="confirm-modal-dialog" size="sm" centered>
        <template #modal-header>
            <button @click="hideModal" type="button" aria-label="Close" class="close">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.355 11.8243L16.878 8.28378C17.0407 8.12162 17.0407 7.87838 16.878 7.71622L16.336 7.14865C16.1734 6.98649 15.9295 6.98649 15.7669 7.14865L12.2168 10.6892C12.1084 10.7973 11.9458 10.7973 11.8374 10.6892L8.28726 7.12162C8.12466 6.95946 7.88076 6.95946 7.71816 7.12162L7.14905 7.68919C6.98645 7.85135 6.98645 8.09459 7.14905 8.25676L10.6992 11.7973C10.8076 11.9054 10.8076 12.0676 10.6992 12.1757L7.12195 15.7432C6.95935 15.9054 6.95935 16.1486 7.12195 16.3108L7.69106 16.8784C7.85366 17.0405 8.09756 17.0405 8.26016 16.8784L11.8103 13.3378C11.9187 13.2297 12.0813 13.2297 12.1897 13.3378L15.7398 16.8784C15.9024 17.0405 16.1463 17.0405 16.3089 16.8784L16.878 16.3108C17.0407 16.1486 17.0407 15.9054 16.878 15.7432L13.355 12.2027C13.2466 12.0946 13.2466 11.9324 13.355 11.8243Z" fill="#0070D2"/>
                </svg>
            </button>
        </template>
        <div class="center-vertical-horizontal">
            <icon name="faExclamationTriangle" size="56" color="inherit" class="text-warning" />
            <span class="m-t-20px text-center" v-html="message"></span>
        </div>
        <template #modal-footer>
            <button class="btn btn-primary save" @click="ok">Yes</button>
            <button class="btn btn-outline-primary btn-outline cancel" @click="cancel">No</button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "ConfirmDialog",
    data() {
        return {
            visible: false,
            message: '',
            resolver: null
        }
    },
    methods: {
        open({ message = '' }) {
            this.message = message
            this.visible = true
            
            return new Promise(resolve => {
                this.resolver = resolve
            })
        },
        ok() {
            this.visible = false
            this.resolver(true)
        },
        cancel() {
            this.visible = false
            this.resolver(false)
        },
        hideModal() {
            this.$refs['confirm-modal-dialog'].hide();
        }
    }
}
</script>

<style lang="scss" scoped>
    :deep(.btn) {
        font-size: 13px;
        line-height: 18px;
        border-radius: 0px;
        padding-top: 6px;
        padding-bottom: 6px;
        &.btn-outline-primary {
            color: #0070D2;
            border-color: #0070D2;
            background-color: #fff;
        }
        &.btn-primary {
            color: #fff;
            border-color: #0070D2;
            background-color: #0070D2;
        }
        &.btn-danger {
            color: #EB5757;
            border-color: #EB5757;
            background-color: #fff;
        }
        &.btn-danger:hover {
            color: #EB5757;
            border-color: #EB5757;
            background-color: #fff;
        }
    }
    :deep(.modal) {
        font-weight: normal;
        .modal-dialog-centered {
            min-height: calc(100% - 3.5rem);
            display: flex;
            align-items: center;
            margin: 1.75rem auto;
        }
        .center-vertical-horizontal {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }
        .close {
            width: 24px;
            height: 24px;
            background-image: none !important;
            opacity: 1;
            position: absolute;
            top: 16px;
            right: 16px;
            svg {
                display: block;
            }
        }
        .modal-header {
            padding: 18px 40px;
            border-bottom: none;
            .modal-title {
                text-align: center;
                font-size: 20px;
                line-height: 23px;
                font-weight: normal;
                span {
                    color: #0070D2;
                }
            }
        }
        .modal-body {
            padding: 16px;
        }
        &.show {
            opacity: 1;
            .modal-dialog {
                transform: none;
            }
        }
        .modal-content {
            border-radius: 2px 0 0 2px;
            width: 100%;
        }
        .modal-footer {
            text-align: left;
            font-size: 0;
            .btn {
                margin-right: 20px;
                &.save {
                    min-width: 125px;
                    margin-right: 0px;
                    margin-left: 0px;
                }
                &.cancel {
                    min-width: 125px;
                    margin-right: 0px;
                    margin-left: 15px;
                }
            }
        }
    }
</style>